<template>
    <div class="container">
        <div v-if="$store.getters.type == 1">
            <el-row class="mb20">
                <span class="f16 bold pr10">数据看板</span>
                <el-button type="primary" size="mini" @click="viewScreen">点击查看数据墙→</el-button>
                <span class="pl10">为学校提供可视化大屏展示本校实时数据，可应用于学校大屏看板墙</span>
                <el-date-picker
                        size="mini"
                        v-model="month"
                        type="month"
                        class="fr"
                        @change="getReportSummary()"
                        placeholder="选择月份">
                </el-date-picker>
            </el-row>
            <el-row :gutter="20" class="mb20 row-1 data">
                <el-col :span="6" class="has-bg">
                    <el-card class="box-card">
                        <!--<i class="icon icon-4"></i>-->

                        <p class="c9 f12">下单数</p>
                        <p class="f24" style="padding-top: 3px;">{{summary.orderSum || 0}}</p>
                        <!--<el-badge :value="summary.orderSum" :max="9999" class="item">-->
                        <!--<el-button>下单数</el-button>-->
                        <!--</el-badge>-->
                    </el-card>
                </el-col>
                <el-col :span="6">
                    <el-card class="box-card">
                        <i class="icon icon-1"></i>
                        <p class="c9 f12">送达率</p>
                        <p class="bold f16" style="padding-bottom: 4px;">{{summary.deliveryRate || 0}}%</p>
                        <el-progress :percentage="summary.deliveryRate" :show-text="false"></el-progress>
                    </el-card>
                </el-col>
                <el-col :span="6">
                    <el-card class="box-card">
                        <i class="icon icon-2"></i>
                        <p class="c9 f12">满意度</p>
                        <p class="bold f16" style="padding-bottom: 4px;">{{summary.satisfactionRate || 0}}%</p>
                        <el-progress :percentage="summary.satisfactionRate" :show-text="false"></el-progress>
                    </el-card>
                </el-col>
                <el-col :span="6">
                    <el-card class="box-card">
                        <i class="icon icon-3"></i>
                        <p class="c9 f12">下单率</p>
                        <p class="bold f16" style="padding-bottom: 4px;">{{summary.orderRate || 0}}%</p>
                        <el-progress :percentage="summary.orderRate" :show-text="false"></el-progress>
                    </el-card>
                </el-col>
            </el-row>
            <el-row :gutter="20" class="mb20 row-2">
                <el-col :span="14">
                    <el-card class="box-card">
                        <p class="bold">
                            销售数据
                            <el-date-picker
                                    size="mini"
                                    class="fr"
                                    v-model="dateRange"
                                    type="daterange"
                                    align="right"
                                    unlink-panels
                                    range-separator="至"
                                    @change="getSalesSummary()"
                                    placeholder="请选择日期">
                            </el-date-picker>
                        </p>
                        <div style="width: 100%;height: 230px;margin-top: 30px;">
                            <IEcharts :option="option2"></IEcharts>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="10">
                    <el-card class="box-card">
                        <p class="bold">下单用户男女比例</p>
                        <div style="width: 100%;height: 250px;margin-top: 10px;">
                            <IEcharts :option="option1" v-if="this.summary.femaleRate != 100"></IEcharts>
                            <p style="color: #5e7382;line-height: 250px;text-align: center" v-if="this.summary.femaleRate == 100">暂无数据</p>
                        </div>
                    </el-card>
                </el-col>
<!--                <el-col :span="10">-->
<!--                    <el-card class="box-card">-->
<!--                        <p class="bold">-->
<!--                            打款状态-->
<!--                            <span class="blue fr">{{summary.remittanceDesc}}</span>-->
<!--                        </p>-->
<!--                        <div style="width: 150px;padding-top: 30px;margin: 0 auto">-->
<!--                            <el-progress type="circle" :percentage="summary.remittanceRate" :show-text="true" :width="150"></el-progress>-->
<!--                        </div>-->
<!--                        <div class="t-c pt10">-->
<!--                        <span style="display: inline-block">-->
<!--                            <i class="f18">已打款</i><br/><i class="f12 red mr5">{{summary.remittance}}</i><i class="f12">笔</i>-->
<!--                        </span>-->
<!--                            <span style="display: inline-block;margin: 0 10px;height: 20px;width: 1px;background-color: #ddd"></span>-->
<!--                            <span style="display: inline-block"><i class="f18">未打款</i><br/><i class="f12 red mr5">{{summary.noRemittance}}</i><i class="f12">笔</i></span>-->
<!--                        </div>-->
<!--                    </el-card>-->
<!--                </el-col>-->
            </el-row>
            <el-row :gutter="20" class="row-2">
                <el-col :span="14">
                    <el-card class="box-card">
                        <p class="bold">营业收入</p>
                        <el-table
                                :data="summary.companyList"
                                height="230"
                                :border="false"
                                class="mt10"
                                style="width: 100%">
                            <el-table-column
                                    prop="name"
                                    label="公司"
                                    :show-overflow-tooltip="true"
                                    width="200">
                            </el-table-column>
                            <el-table-column
                                    prop="amount"
                                    label="营业额"
                                    width="160">
                            </el-table-column>
                            <el-table-column
                                    prop="rate"
                                    label="占比">
                                <template slot-scope="scope">
                                    <el-progress :percentage="scope.row.rate ? scope.row.rate : 0"></el-progress>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </el-col>
<!--                <el-col :span="10">-->
<!--                    <el-card class="box-card">-->
<!--                        <p class="bold">下单用户男女比例</p>-->
<!--                        <div style="width: 100%;height: 250px;margin-top: 10px;">-->
<!--                            <IEcharts :option="option1" v-if="this.summary.femaleRate != 100"></IEcharts>-->
<!--                            <p style="color: #5e7382;line-height: 250px;text-align: center" v-if="this.summary.femaleRate == 100">暂无数据</p>-->
<!--                        </div>-->
<!--                    </el-card>-->
<!--                </el-col>-->
            </el-row>
        </div>
        <div  v-if="$store.getters.type != 1">
            <el-row>
                <blockquote class="elem-quote">
                    <p>郑重提示：您可操作的权限如下,请严格按照规定操作</p>
                </blockquote>
            </el-row>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import IEcharts from 'vue-echarts-v3';

    export default {
        components: { IEcharts },
        name: 'dashboard',
        computed: {

        },
        data() {
            return{
                month: '',
                startDate: '',
                endDate: '',
                summary: {
                  deliveryRate: 0,
                  orderRate: 0,
                  satisfactionRate: 0,
                  femaleRate: 0,
                  orderSum: 0,
                  companyList: [],
                },
                dateRange: [],
                option1: {
                    title : {
                        x:'center'
                    },
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c}%"
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'right',
                        data: ['女','男']
                    },
                    series : [
                        {
                            name: '下单用户男女比例',
                            type: 'pie',
                            radius : '55%',
                            center: ['50%', '60%'],
                            data:[],
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.3)'
                                }
                            }
                        }
                    ]
                },
                option2: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    grid: {
                        left: '65',
                        right: '55'
                    },
                    toolbox: {

                    },
                    legend: {
                        data:['营业额','订单量']
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: [],
                            axisPointer: {
                                type: 'shadow'
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            name: '营业额（元）',
                            // min: 0,
                            // max: 60000,
                            // interval: 12000,
                            // axisLabel: {
                            //     formatter: '{value} 元'
                            // }
                        },
                        {
                            type: 'value',
                            name: '订单数（单）',
                            // min: 0,
                            // max: 10000,
                            // interval: 2000,
                            // axisLabel: {
                            //     formatter: '{value} 单'
                            // }
                        }
                    ],
                    series: [
                        {
                            name:'营业额',
                            type:'bar',
                            barWidth: '20',
                            data:[]
                        },
                        {
                            name:'订单量',
                            type:'line',
                            yAxisIndex: 1,
                            data:[]
                        }
                    ]
                }
            }
        },
        created (){
            if(localStorage.getItem('type') == 1){
                this.month = new Date();
                //默认显示最近一周
                var day = new Date();
                day.setTime(day.getTime()-6*24*60*60*1000);
                this.dateRange = [day,new Date()];
                this.getReportSummary(true);
                this.getSalesSummary();
            }
        },
        methods: {
            //报表数据
            getReportSummary(f) {
                this.$apiJava.get(this.$apiUrl.reportSummary,{month: moment(this.month).format('YYYYMM')},(res)=>{
                    this.summary = res.data;
                    this.option1.series[0].data = [{name:'女',value:res.data.femaleRate},{name:'男',value:res.data.maleRate}];
                },null,'oc')
                if(!f){
                    let temp = new Date(moment(this.month).format('YYYY'),moment(this.month).format('MM'),0);
                    let day = new Date(moment(this.month).format('YYYY'),moment(this.month).format('MM'),0);
                    day.setTime(day.getTime()-6*24*60*60*1000);
                    this.dateRange = [day,temp];
                }
            },
            //销量
            getSalesSummary() {
                this.startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
                this.endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');
                this.$apiJava.post(this.$apiUrl.salesSummary,{startDate: this.startDate,endDate: this.endDate},(res)=>{
                    if(res.data.dailyCount){
                        this.option2.xAxis[0].data = [];
                        this.option2.series[0].data = [];
                        this.option2.series[1].data = [];
                        for(let k in res.data.dailyCount){
                            this.option2.xAxis[0].data.push(k);
                            this.option2.series[0].data.push(res.data.dailyCount[k].amount);
                            this.option2.series[1].data.push(res.data.dailyCount[k].orderNum);
                        }

                    }
                },null,'oc')
            },
            viewScreen() {
                let id = localStorage.getItem('schoolId');
                window.open('https://adadmin.anlaiye.com/master/order/share?code=cef34590c5e4646f4ca571c6d21e5c65&&canteenId=-1&mixMode=1&exchangeMode=1&schoolId='+parseInt(id)*2573);
                // let url = location.href;
                // if(url.indexOf('anlaiye') > -1){
                //     window.open('https://special.anlaiye.com/theme/v1/h5/201912/index.html?schoolId='+parseInt(id)*2573 + '&code=' + '9594192783440faae541c8f1362d2139')
                // }else {
                //     window.open('http://special.imcoming.com/theme/v1/h5/201912/index.html?schoolId='+parseInt(id)*2573 + '&code=' + '91e1daee0646ab7dd12bc8633a7ad38e')
                // }
            }
        },
        mounted() {

        }
    }
</script>
<style lang="scss"  scoped>
    .box{
        width: 100%;
        height: 150px;
    }
    .row-1 .el-card{
        height: 100px;
        position: relative;
    }
    .row-2 .el-card{
        height: 305px;
    }
    .data{
        p{
            line-height: 24px;
        }
        .has-bg .el-card{
            background-image: url("../../images/bo.png");
            background-position: left bottom;
            background-repeat: no-repeat;
            background-size: 100% auto;
            /*border: none;*/
            /*box-shadow: none;*/
        }
    }

    .icon{
        position: absolute;
        right: 20px;
        top: 20px;
        width: 32px;
        height: 32px;
        &.icon-1{
            background-image: url("../../images/icon-1.png");
            background-repeat: no-repeat;
            background-size: 100% auto;
        }
        &.icon-2{
            background-image: url("../../images/icon-2.png");
            background-repeat: no-repeat;
            background-size: 100% auto;
        }
        &.icon-3{
            background-image: url("../../images/icon-3.png");
            background-repeat: no-repeat;
            background-size: 100% auto;
        }
        &.icon-4{
            background-image: url("../../images/icon-4.png");
            background-repeat: no-repeat;
            background-size: 100% auto;
        }
    }
    @media screen and (max-width: 840px){
        .el-col-6,
        .el-col-14,
        .el-col-10{
            width: 100%;
            margin-bottom: 10px;
        }
        .el-col-6{
            width: 50%;
            margin-bottom: 10px;
        }
        .el-date-editor--daterange.el-input{
            width: 160px;
        }
    }
</style>


// WEBPACK FOOTER //
// index.vue?7ead730b